import React from 'react'

const AdminsCard = ({admins}) => {
  return (
    <div className="col-lg-4 default-according ">
    <div class="card">
      <div class="card-header">
        <h5 class="p-0">
          <button
            type="button"
            class="btn btn-link ps-0 btn btn-transperant">
            المدراء
          </button>
        </h5>
      </div>
      <div
        class="collapse show"
        id="collapseicon8"
        aria-labelledby="collapseicon8"
        data-parent="#accordion">
        {admins.map((admin) => (
          <div
            class="social-list filter-cards-view card-body"
            key={admin.id}>
            <div class="media">
              <img
                src=""
                alt=""
                class="img-50 img-fluid m-r-20 rounded-circle mb-0 media"
              />
              <div class="media-body">
                <span class="d-block">{admin.name_ar}</span>
                <a href="#javascript">{admin.name_en}</a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
  )
}

export default AdminsCard